@if (vmData$ | async; as vmData) {
  @if (vmData.loadingState.isLoaded) {
    @if (vmData.opportunity && vmData.client) {
      <app-opportunity-results
        [opportunity]="vmData.opportunity"
        [client]="vmData.client"
        [selectedPhase]="activePhase"
      >
      </app-opportunity-results>
    } @else {
      Missing opportunity/client data
    }
  }
}
